(function () {
  'use strict';

  angular
    .module('settings.customization.custom.field')
    .factory('CustomFieldCustomization', CustomFieldCustomization);

  CustomFieldCustomization.$inject = ['$resource'];

  function CustomFieldCustomization($resource) {
    return $resource(
      '/api/',
      {},
      {
        getCustomFieldList: {
          method: 'GET',
          url: 'api/customization/all_custom_field/:field_for',
          isArray: true,
        },
        createCustomField: {
          method: 'POST',
          url: 'api/customization/create_custom_field/:field_for',
        },
        updateCustomField: {
          method: 'POST',
          url: 'api/customization/update_custom_field/:id',
        },
        deleteCustomField: {
          method: 'POST',
          url: 'api/customization/delete_custom_field/:id',
        },
      },
    );
  }
})();
